import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';

export const TimeTracking: NavigationWrapper = {
  title: 'Zeiterfassung',
  route: ShiveRoutes.TimeTracking,
};

export const CalendarView: NavigationWrapper = {
  title: 'Kalenderansicht',
  route: ShiveRoutes.CalendarView,
};

export const ListView: NavigationWrapper = {
  title: 'Listenansicht',
  route: ShiveRoutes.ListView,
};
